import { FaCheckCircle, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const PaymentSuccessful = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-base-200 h-full flex flex-col gap-2 items-center p-2 animate-fade-in">
      <div className="card bg-base-100 w-full sm:w-6/12 h-full border-2 border-success">
        <div className="card-body p-2 sm:p-4 h-full flex flex-col justify-center items-center">
          <div className="card-title justify-between">
            <div>Payment Successful</div>
          </div>
          <div className="text-success">
            <FaCheckCircle size={50} />
          </div>
          <button className="btn btn-primary" onClick={() => navigate("/home")}>
            Go Home <FaHome size={24} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessful;
